import { centsToYuan } from '@/utils/amount'
import { formatTimestamp } from '@/utils/time'

const PAYIN_STATUS_MAP = {
  1: '待确认',
  2: '自动处理中',
  4: '发货失败',
  5: '存款成功',
  6: '已退款',
}

export function mapPayinStatusText(status) {
  return PAYIN_STATUS_MAP[status] || '未知状态'
}

export function mapPayinHistoryRow(item) {
  return {
    uid: item.uid,
    orderNo: item.order_id ?? item.id ?? '',
    thirdOrderNo: item.third_order_id || '',
    memberAccount: item.username,
    memberLevel: item.vip_level,
    orderAmount: item.amount,
    total_fee: centsToYuan(item.total_fee),
    arrivalAmount: item.real_amount - item.total_fee,
    topUpAmount: item.gold,
    depositDiscount: item.bonus_gold,
    payment_channel: item.payment_channel_name || '',
    payin_method: item.payin_method || '',
    orderTime: formatTimestamp(item.created_at),
    completeTime: formatTimestamp(item.updated_at),
    status: mapPayinStatusText(item.status),
  }
}
